import { render, staticRenderFns } from "./ScrollTabs.vue?vue&type=template&id=4de91244&"
import script from "./ScrollTabs.vue?vue&type=script&lang=ts&"
export * from "./ScrollTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollTabs.vue?vue&type=style&index=0&id=4de91244&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports